// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"qWpNd40sBq_calculator","actionButton":"MtuYou4fIV_calculator","extraButton":"_ZMNXdzTcz_calculator"};